import React, { useState } from 'react';
import Modal from '@app/react-common/components/modal/Modal';
import Button from '@app/react-common/components/button/Button';
import Input from '@app/react-common/components/input/Input';

interface SegmentModalProps {
  isOpen;
  onClose;
  onRenameSuccess?: (segment: SegmentFormData) => Promise<void>;
  segmentName?: string;
}

export interface SegmentFormData {
  name: string;
}

export const SegmentModal: React.FC<SegmentModalProps> = (props: SegmentModalProps) => {
  const [formData, setFormData] = useState<SegmentFormData>({
    name: props?.segmentName || '',
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const buttonClick = async () => {
    if (formData.name === '') return;

    props.onRenameSuccess(formData);
  };

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose}>
      <div className="segment-modal">
        <h2 className="segment-modal__title">Rename segment</h2>
        <Input
          type="text"
          placeholder="Segment name"
          label="Segment name"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
        />
        <div className="segment-modal__actions">
          <Button
            onClick={props.onClose}
            text={'Cancel'}
            size={'medium'}
            variant={'secondary'}
            className="segment-modal__actions__cancel"
          />
          <Button
            disabled={formData.name.length == 0 || formData.name == props.segmentName}
            onClick={buttonClick}
            text={'Save'}
            size={'medium'}
            variant={'primary'}
          />
        </div>
      </div>
    </Modal>
  );
};
